import { actionType } from '../actions/merchant';
import baseInitState from '../baseInitState';
import baseReducer from '../baseReducer';

const initState = {
  ...baseInitState,
};

export default function merchant(state = initState, action) {
  switch (action.type) {
    case actionType('fetchList').request:
      return {
        ...state,
        isLoading: true,
      };
    case actionType('fetchList').success:
      return {
        ...state,
        isLoading: false,
        dataList: action.response?.data?.data || [],
        pagination: {
          currentPage: action.response?.data?.paging?.page || 1,
          lastPage: action.response?.data?.paging?.total_page || 1,
          count: action.response?.data?.paging?.total_record || 0,
          recordPerPage: action.response?.data?.paging?.size || 10,
        },
        params: action.params,
      };
    case actionType('fetchList').error:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return baseReducer(state, action, actionType);
  }
}
